import { render, staticRenderFns } from "./entry_life_record_appointment_import.vue?vue&type=template&id=10f6afbf"
import script from "./entry_life_record_appointment_import.vue?vue&type=script&lang=js"
export * from "./entry_life_record_appointment_import.vue?vue&type=script&lang=js"
import style0 from "./entry_life_record_appointment_import.vue?vue&type=style&index=0&id=10f6afbf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports